import { render, staticRenderFns } from "./vGenericTable.vue?vue&type=template&id=77618d8c&scoped=true"
import script from "./vGenericTable.vue?vue&type=script&lang=ts"
export * from "./vGenericTable.vue?vue&type=script&lang=ts"
import style0 from "./vGenericTable.vue?vue&type=style&index=0&id=77618d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77618d8c",
  null
  
)

export default component.exports